<template>
  <div id="listAarquios">
    <v-layout v-resize="onResize" style="display:flex;flex-flow: column;">
      <v-container
        v-if="loadinData"
        style="height: 400px;display: flex;margin-top:150px;
    justify-content: center;"
      >
        <v-row class="fill-height" align-content="center" justify="center">
          <v-col class="subtitle-1 text-center" cols="12">Baixando dados..</v-col>
          <v-col cols="6">
            <v-progress-linear color="#88C658" indeterminate rounded height="6"></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <div v-else>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="headers"
          rows-per-page-text="Items por página"
          :items="arquivosArr"
          :hide-headers="isMobile"
          :class="{mobile: isMobile}"
          item-key="ARQMD5"
          :pagination.sync="pagination"
          no-data-text="Nada foi encontrado."
          no-results-text="Nada foi encontrado."
          :search="search"
          style="width: 100%!important;"
          :rows-per-page-items="[
              {
                text: '100',
                value: 100
              },
              {
                text: '300',
                value: 300
              },
              {
                text: '500',
                value: 500
              },
              {
                text: 'Todos',
                value: -1
              }
            ]"
        >
          <template v-slot:items="props">
            <tr v-if="!isMobile">
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.ARQNOME || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.ARQVERSAO || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.ARQTIPO || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.ARQDESTINO || "---" }}</td>
              <td class="text-xs-left" @click="props.expanded = !props.expanded">
                <div class="copy">
                  {{ props.item.ARQMD5.substring(0, 15)+"..." || "---" }}
                  <font-awesome-icon
                    v-clipboard="props.item.ARQMD5"
                    @click="msg = 'Copiado com sucesso.'"
                    class="iconcopy"
                    icon="copy"
                  />
                </div>
              </td>
              <td class="text-xs-left" @click="props.expanded = !props.expanded">
                <div style="display: flex;padding-top:20px">
                  <v-switch
                    @change="toogleArquivoAtivo(props.item)"
                    v-model="props.item.ARQATIVO"
                    color="#88C658"
                  ></v-switch>
                </div>
              </td>
              <td class="text-xs-left">
                <v-btn
                  color="#88C658"
                  class="ma-2 white--text"
                  small
                  fab
                  v-clipboard="props.item.ARQURL"
                  @click="msg = 'Copiado com sucesso.'"
                >
                  <font-awesome-icon icon="copy" />
                </v-btn>
                <v-btn
                  :loading="props.item.loading"
                  :disabled="props.item.loading"
                  color="#88C658"
                  class="ma-2 white--text"
                  small
                  fab
                  @click="downloadWFile(props.item)"
                >
                  <v-icon dark>cloud_download</v-icon>
                </v-btn>
                <v-btn
                  :loading="props.item.loading"
                  :disabled="props.item.loading"
                  color="#88C658"
                  class="ma-2 white--text"
                  small
                  fab
                  @click="deletaArquivo(props.item)"
                >
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-else>
              <td style="margin-bottom:25px">
                <ul class="flex-content">
                  <li class="flex-item" data-label="Nome:">{{ props.item.ARQNOME }}</li>
                  <li class="flex-item" data-label="Versão:">{{ props.item.ARQVERSAO }}</li>
                  <li class="flex-item" data-label="Tipo:">{{ props.item.ARQTIPO }}</li>
                  <li
                    class="flex-item"
                    data-label="Destino:"
                    style="word-wrap:break-word;"
                  >{{ props.item.ARQDESTINO }}</li>
                  <li
                    class="flex-item"
                    data-label="MD5"
                  >{{ props.item.ARQMD5.substring(0, 15)+"..." || "---" }}</li>
                  <li class="flex-item" data-label="Ativo">
                    <v-switch
                      @change="toogleArquivoAtivo(props.item)"
                      v-model="props.item.ARQATIVO"
                      color="#88C658"
                    ></v-switch>
                  </li>
                  <li class="flex-item" data-label="Ações">
                    <v-btn
                      color="#88C658"
                      class="ma-2 white--text"
                      small
                      fab
                      v-clipboard="props.item.ARQURL"
                      @click="msg = 'Copiado com sucesso.'"
                    >
                      <font-awesome-icon icon="copy" />
                    </v-btn>
                    <v-btn
                      :loading="props.item.loading"
                      :disabled="props.item.loading"
                      color="#88C658"
                      class="ma-2 white--text"
                      small
                      fab
                      @click="downloadWFile(props.item)"
                    >
                      <v-icon dark>cloud_download</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="props.item.loading"
                      :disabled="props.item.loading"
                      color="#88C658"
                      class="ma-2 white--text"
                      small
                      fab
                      @click="deletaArquivo(props.item)"
                    >
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </li>
                </ul>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              style="color: #000!important"
            >Nada foi encontrado.</v-alert>
          </template>

          <template
            slot="pageText"
            slot-scope="item"
          >Exibindo {{item.pageStart}} - {{item.pageStop}}, Total {{item.itemsLength}}</template>
        </v-data-table>
      </div>
    </v-layout>

    <md-snackbar :md-active.sync="empSaved">Sucesso!</md-snackbar>
    <md-snackbar :md-active.sync="errorSaved">Erro interno do servidor</md-snackbar>
    <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>
<script>
import * as Arquivos from "../../providers/arquivos.service";

export default {
  name: "tabela-clientes",
  components: {
    Map
  },
  data() {
    return {
      isMobile: false,
      search: "",
      loadinData: true,
      loading5: false,
      endereco: false,
      coords: false,
      msg: false,
      pagination: { rowsPerPage: 100 },
      activemap: false,
      errorSaved: false,
      empSaved: false,
      arquivosArr: [],
      headers: [
        {
          text: "Nome",
          value: "ARQNOME"
        },
        {
          text: "Versão",
          value: "ARQVERSAO"
        },
        {
          text: "Tipo",
          value: "ARQTIPO"
        },
        {
          text: "Destino",
          value: "ARQDESTINO"
        },
        {
          text: "MD5",
          value: "ARQMD5"
        },
        {
          text: "Ativo",
          value: "ARQATIVO"
        },
        {
          text: "Download",
          value: "ARQURL"
        }
      ],
      desserts: []
    };
  },

  methods: {
    deletaArquivo(data) {
      var self = this;
      Arquivos.deletaArquivo(data).then(r => {
        self.msg = r.Message;
        self.findData();
      });
    },
    toogleArquivoAtivo(arquivo) {
      var self = this;
      var body = {
        ARQATIVO: arquivo.ARQATIVO ? 1 : 0,
        ARQMD5: arquivo.ARQMD5
      };
      Arquivos.toogleArquivoAtivo(body).then(r => {
        self.msg = r.Message;
      });
    },
    downloadWFile(item) {
      var self = this;
      item.loading = true;
      self.forceFileDownload(item);
    },
    forceFileDownload(item) {
      this.msg = "Seu download começou..";
      var win = window.open(item.ARQURL, "_blank");

      item.loading = false;
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    mapclosed() {
      this.activemap = false;
      this.coords = false;
      this.endereco = false;
    },
    findData() {
      var self = this;
      Arquivos.getArquivos().then(resp => {
        self.arquivosArr = resp;
        self.loadinData = false;
      });
    }
  },
  created() {
    var self = this;
    self.findData();
  }
};
</script>
<style scoped>
.copy {
  position: relative;
}
.copy .iconcopy {
  opacity: 0;
  position: absolute;
  color: rgb(97, 97, 97);
  top: 0;
}
.copy:hover .iconcopy {
  opacity: 1;
  cursor: pointer;
}
li {
  min-height: 58px;
}
.iconedit {
  font-size: 15px !important;
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0;
  cursor: pointer;
}
.descarrude:hover .iconedit {
  opacity: 1;
}
.iconedit:hover {
  font-size: 16px !important;
  position: absolute;
  color: #000 !important;
  top: 5px;
}
</style>
<style>
#listAarquios .v-datatable__actions__select {
  opacity: 0;
  display: none !important;
}
</style>